import React from "react";
import { FormSurveySvgIcon } from "../../common/CustomIcon";
import SurveyResponse from "../surveys/SurveyResponse";
import OrderItemDetails from "./OrderItemDetails";

const OrderSurveyDetails = ({ isFormFilled, currentOrder, location }) => {
  return (
    <OrderItemDetails
      isFilled={isFormFilled}
      currentOrder={currentOrder}
      location={location}
      type="Survey"
      IconComponent={FormSurveySvgIcon}
      ResponseComponent={SurveyResponse}
    />
  );
};

export default OrderSurveyDetails;
